import { THEMES } from '../constants/Consts';
import { PracticeMenu } from '../pages/PracticeMenu';
import { Practice } from '../pages/Practice';
import { DisplayError } from '../pages/DisplayError';
import { ReactElement } from 'react';
import { TypingUnavailable } from '../pages/TypingUnavailable';

export interface PermitGuardRouteConfig {
  path: string;
  element: ReactElement;
  isJudge?: boolean;
  themeType?: THEMES;
}

const THEMES_LIST: THEMES[] = [THEMES.DISNEY, THEMES.MICRATCH, THEMES.ROBLOX];

const createRoutesByThemeList = (): PermitGuardRouteConfig[] => {
  const routes: PermitGuardRouteConfig[] = [];

  THEMES_LIST.forEach((theme) => {
    routes.push({
      path: `/practice/${theme}`,
      element: <PracticeMenu themeType={theme} />,
      isJudge: true,
      themeType: theme,
    });

    routes.push({
      path: `/practice/${theme}/:grade`,
      element: <Practice themeType={theme} />,
      isJudge: true,
      themeType: theme,
    });
  });

  return routes;
};

export const RouteConfig: PermitGuardRouteConfig[] = [
  ...createRoutesByThemeList(),

  {
    path: '/practice/unavailable',
    element: <TypingUnavailable />,
    isJudge: false,
  },

  {
    path: '/error',
    element: <DisplayError />,
    isJudge: false,
  },
  {
    path: '/error/network',
    element: <DisplayError message="インターネットにせつぞくできなかったみたい・・・" />,
    isJudge: false,
  },
  {
    path: '/error/unknown',
    element: <DisplayError message="エラーがはっせいしたみたい・・・" />,
    isJudge: false,
  },
  {
    path: '*',
    element: <DisplayError />,
    isJudge: false,
  },
];
